import type { RoomsParticipantDistribution } from '@/domain/shared/types';

export interface Option {
  name: string;
  value: string;
  resultsCount?: string;
  groupInfo?: string;
  selected?: boolean;
}
export interface FiltersResponse {
  DepartureAirport: MultiSelectPricesFilter;
  Duration: MultiSelectPricesFilter;
  Mealplan: MultiSelectPricesFilter;
  Month: MultiSelectPricesFilter;
  TransportType: MultiSelectPricesFilter;
  RoomType: MultiSelectPricesFilter;
  Participants: RoomsParticipantDistribution;
}

export interface MultiSelectPricesFilter {
  options: Option[];
}

export interface Option {
  name: string;
  value: string;
  resultsCount?: string;
  groupInfo?: string;
  selected?: boolean;
}
export type FilterSelection = MultiSelectFilters & SelectFilters & ParticipantsFilter & DepartureDateFilter;
//TODO: Move to config file
export const defaultFilterSelection: FilterSelection = {
  Participants: [
    {
      adults: 2,
      children: [],
      babies: [],
    },
  ],
};
//TODO: Move to config file
export const defaultFilterOptions = {
  DepartureAirport: { options: [] },
  Duration: { options: [] },
  Mealplan: { options: [] },
  Month: { options: [] },
  TransportType: { options: [] },
  RoomType: { options: [] },
};

export type PricesFilterOptions = Partial<FiltersResponse>;

export type PricesFilterType = keyof Omit<PricesFilterOptions, 'RoomType'>;

export interface MultiSelectFilters {
  DepartureAirport?: string[];
  Duration?: string[];
  RoomType?: string[];
}

export interface SelectFilters {
  Mealplan?: string;
  Month?: string;
  TransportType?: string;
}

export interface ParticipantsFilter {
  Participants?: RoomsParticipantDistribution;
}

export interface DepartureDateFilter {
  DepartureDate?: string[];
}

export type MultiselectFilterType = keyof MultiSelectFilters;
export type SelectFilterType = keyof SelectFilters;
export type FilterType = MultiselectFilterType & SelectFilterType;
